import { FormLabel as ChakraFormLabel } from "@chakra-ui/react"

import { IFormLabelProps } from "./FormLabelTypes"

const FormLabel: React.FC<IFormLabelProps> = ({ id, text, opacity, color = "main_text_color", style }) => (
  <ChakraFormLabel htmlFor={id} fontSize="base" color={color} opacity={opacity} style={style}>
    {text}
  </ChakraFormLabel>
)

export default FormLabel
